import { Slide, TextProps } from '@features/powerpoint';
import { COVER_SLIDE } from '../utils';
import { theme } from '../domain/theme';
import { personTargetOutlineWhite } from '../images';

type CoverSlideOptions = {
  titleText: TextProps['text'];
  bold?: boolean;
};

export const coverSlide = (options: CoverSlideOptions): Slide => ({
  slideMaster: COVER_SLIDE,
  texts: [
    {
      text: options.titleText,
      options: {
        fontSize: 40,
        bold: options.bold ?? true,
        color: theme.colors.white,
        h: 0.77,
        w: 8.52,
        x: 0.8,
        y: 3.91,
        charSpacing: theme.charSpacing.tight,
      },
    },
  ],
  images: [
    {
      path: personTargetOutlineWhite,
      h: 0.94,
      w: 0.94,
      x: 1,
      y: 2.61,
    },
  ],
  shapes: [
    {
      shapeName: 'ellipse',
      options: {
        line: {
          color: theme.colors.inmarketGreen,
          width: 2,
        },
        h: 1.34,
        w: 1.34,
        x: 0.8,
        y: 2.41,
      },
    },
  ],
});
